import AppFooter from "../AppFooter";

const ReturnPolicy = () => {
    return (
        <>
            <div className="grid">
                <div className="col-12">
                    <div className="card docs">
                        <h4>Return Policy:</h4>


                        We want you to be completely satisfied with your purchase from our website. If for any reason you are not, please follow our return policy guidelines below.
                        <h6>Returns:</h6>
                        We accept returns within 7 days of delivery. To initiate a return, please contact our customer support team 73377 66088/ 994581 1771/ 99723 74918 to obtain a Return Merchandise Authorization (RMA) number. Please include your order number, the item(s) you wish to return, and the reason for the return in your message.
                        Returned items must be in their original packaging, unused, and in the same condition as when you received them. We reserve the right to refuse returns of any merchandise that does not meet the above return requirements.
                        <h6>Refunds:</h6>
                        Once we receive your returned item(s) and verify that they meet our return requirements, we will issue a refund to your original payment method within 5-7 business days. Please note that we do not refund shipping fees and you are responsible for the return shipping costs.
                        <h6>Exchanges:</h6>
                        At this time, we do not offer exchanges. If you would like to exchange an item, please return the original item(s) for a refund and place a new order.
                        <h6>Damaged or Defective Items:</h6>
                        If you receive a damaged or defective item, please contact our customer support team immediately at <b>mahesha@desiri.in (or) 9972374918</b> We will work with you to resolve the issue as quickly as possible.

                    </div>
                </div>
            </div>
            <AppFooter />

        </>
    );
};

export default ReturnPolicy;
